module.exports = __webpack_public_path__ + "static/media/sfondo-contacts.f80d57a8.jpg";